@let portalOrder = portalOrder$ | async;
@let state = stateService.getState();

@if (portalOrder && tier) {
  <stepper [step]="Steps.BookingOptions" [tierChangeMode]="true" />

  <div class="tier-change d-flex flex-column flex-md-row p-4 p-md-0 py-md-6 g-8 g-md-5">
    <div class="tier-change-main flex-1">
      <h2 class="semi-bold">Your booking option</h2>

      <p class="mt-2">Flexibility, protection & expert support for this trip</p>

      <div class="tier-change-banner d-flex align-items-start g-2 p-4 mt-4 mb-4 text-blue-500">
        <img src="/assets/icons/info-blue.svg" alt="info-blue" width="20" height="20" />
        <div class="d-flex flex-column g-1">
          <p class="semi-bold">{{ bannerTitle }}</p>
          <p>{{ bannerBody }}</p>
        </div>
      </div>

      <div class="plan-card p-4 p-md-6">
        <p class="plan-label caption-small semi-bold text-lightblue-800">{{ planCardLabel }}</p>

        <h1 class="plan-card-title semi-bold mt-2">{{ tier.label }}</h1>

        <div class="d-flex flex-row align-items-start g-4 mt-4 d-md-none">
          <div class="d-flex flex-column g-4 flex-1">
            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/airplane_ticket.svg"
                alt="airplane_ticket"
                width="20"
                height="20"
              />
              <p>{{ tier.base.protection }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/airplanemode_inactive.svg"
                alt="airplanemode_inactive"
                width="20"
                height="20"
              />
              <p>{{ tier.base.cancellation }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img src="/assets/icons/money.svg" alt="money" width="20" height="20" />
              <p>{{ tier.base.changes }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/support_agent.svg"
                alt="support_agent"
                width="20"
                height="20"
              />
              <p>{{ tier.base.concierge }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img src="/assets/icons/payments.svg" alt="payments" width="20" height="20" />
              <p>{{ tier.base.cashback }}</p>
            </div>
          </div>

          <img
            [src]="'/assets/images/3d-' + tier.img + '.webp'"
            [alt]="tier.img"
            width="120"
            height="120"
            class="plan-card-img"
          />
        </div>

        <div class="d-none d-md-flex flex-row align-items-center g-8 mt-4">
          <div class="d-flex flex-column g-4 flex-1">
            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/airplane_ticket.svg"
                alt="airplane_ticket"
                width="20"
                height="20"
              />
              <p>{{ tier.base.protection }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img src="/assets/icons/money.svg" alt="money" width="20" height="20" />
              <p>{{ tier.base.changes }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img src="/assets/icons/payments.svg" alt="payments" width="20" height="20" />
              <p>{{ tier.base.cashback }}</p>
            </div>
          </div>

          <div class="d-flex flex-column g-4 flex-1">
            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/airplanemode_inactive.svg"
                alt="airplanemode_inactive"
                width="20"
                height="20"
              />
              <p>{{ tier.base.cancellation }}</p>
            </div>

            <div class="d-flex g-2 align-items-start">
              <img
                src="/assets/icons/support_agent.svg"
                alt="support_agent"
                width="20"
                height="20"
              />
              <p>{{ tier.base.concierge }}</p>
            </div>
          </div>

          <img
            [src]="'/assets/images/3d-' + tier.img + '.webp'"
            [alt]="tier.img"
            width="120"
            height="120"
            class="plan-card-img"
          />
        </div>
      </div>
    </div>

    <div class="tier-change-summary checkout-summary mt-8 mt-md-0">
      <ng-container *ngTemplateOutlet="summaryBlock" />
    </div>

    <div class="d-flex flex-column g-2 mt-8 d-md-none">
      @if (showForfeitOption) {
        <ds-button
          (click)="continueWithPlan()"
          [fullWidth]="true"
          class="w-md-unset"
          data-id="retain"
          [label]="'Continue with ' + planName"
        />

        <ds-button
          (click)="continueWithoutProtection()"
          variant="secondary"
          [fullWidth]="true"
          class="w-md-unset"
          data-id="forfeit"
          label="Continue without protection"
        />
      } @else if (showSingleContinue) {
        <ds-button
          (click)="continueToGratuity()"
          [fullWidth]="true"
          class="w-md-unset"
          data-id="continue"
          label="Next: Gratuity →"
        />
      }

      <ds-button
        (click)="back()"
        variant="secondary"
        [fullWidth]="true"
        class="w-md-unset"
        leadingIcon="chevronLeft"
        data-id="back"
        label="Back"
      />
    </div>
  </div>
}

<ng-template #summaryBlock>
  @if (portalOrder) {
    <price-summary
      [option]="portalOrder"
      [tier]="state.tier ?? changeTierType"
      [tipsAmount]="state.tipsAmount"
      [promocodeDiscountAmount]="state.promocodeDiscountAmount"
      [actions]="summaryActions"
      (actionClick)="onSummaryAction($event)"
    />
  }
</ng-template>

<ng-template #askToSignInTemplate>
  <ask-to-sign-in-modal
    (hideModal)="hideModal()"
    (continueAsGuest)="hideModal(); redirect()"
    (showSignInModal)="showSignInModal()"
  />
</ng-template>
